<script>
  import { createEventDispatcher } from "svelte"
  export let dialog // （←ポイント） 要素をバインドすることで親側で表示・閉じるの制御が可能に
  export let idNumber
  export let text
  export let closeText
  export let nextText

  const dispatch = createEventDispatcher()
  function clickClose() {
    dispatch("closeDialog")
  }
  function clickNext() {
    dispatch("nextDialog")
  }
</script>

<dialog bind:this={dialog}>
  <div class="inner">
    {#if idNumber}
      <h2>{idNumber}</h2>
    {/if}
    <p>{text}</p>
    <div class="buttons">
      <button class="back-dialog-button" on:click={clickClose}>
        {closeText}
      </button>
      <button class="next-dialog-button indigo" on:click={clickNext}>
        {nextText}
      </button>
    </div>
  </div>
</dialog>

<style>
  .buttons {
    display: flex;
    justify-content: center;
  }
  button {
    width: auto;
  }
  .back-dialog-button {
    margin-right: 5vh;
    color: black;
    outline-color: #3f51b5;
  }
  .next-dialog-button {
    margin-left: 5vh;
  }
  .inner {
    text-align: center;
    word-break: keep-all;
  }

  @media screen and (min-width: 768px) and (max-width: 1024px) {
    dialog {
      min-width: 500px;
      padding: 2rem;
    }

    .inner h2 {
      font-size: 2rem;
      margin-bottom: 1.5rem;
    }

    .inner p {
      font-size: 1.2rem;
      line-height: 1.6;
      margin: 1.5rem 0;
    }

    .buttons {
      margin-top: 2rem;
      gap: 2rem;
    }

    .buttons button {
      padding: 0.8rem 1.5rem;
      font-size: 1.1rem;
      min-width: 120px;
    }

    .back-dialog-button {
      margin-right: 0;
    }

    .next-dialog-button {
      margin-left: 0;
    }
  }
</style>
